/**
 * @generated SignedSource<<3b9dd28bbff155bac38ac6dfc709cf91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TotalEffortInput_account$data = {
  readonly default_full_time_minutes: number;
  readonly " $fragmentType": "TotalEffortInput_account";
};
export type TotalEffortInput_account$key = {
  readonly " $data"?: TotalEffortInput_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TotalEffortInput_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TotalEffortInput_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default_full_time_minutes",
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "03e549ea478a5a46fd81d2f37b02b0ed";

export default node;
